// extracted by mini-css-extract-plugin
export default {"chip":"GettonciniCostChip_chip__MImG-","amount":"GettonciniCostChip_amount__JmYVS","icon":"GettonciniCostChip_icon__xpg3Q","compact":"GettonciniCostChip_compact__dIToV"};